/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BotExamReviewQuestionOptionViewModel } from "../types/BotExamReviewQuestionOptionViewModel.ts";

export const botExamReviewQuestionOptionViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID da alternativa da questão bot."),
  ),
  label: z
    .string()
    .describe("Texto da alternativa gerada pelo bot. Opcional.")
    .nullish(),
  isCorrect: z.optional(
    z
      .boolean()
      .describe("Indica se esta alternativa é a resposta correta da questão."),
  ),
}) as unknown as ToZod<BotExamReviewQuestionOptionViewModel>;
